import { useQueryOrderRequestFlowPreference } from '../../models/useQueryOrderRequestFlowPreference'

export const useGetOrderRequestFlowPreferencePresenter = (userId: number) => {
  const { preferredOrderRequestFlow, isFetching } =
    useQueryOrderRequestFlowPreference(userId)

  return {
    data: {
      preferredOrderRequestFlow,
    },
    states: {
      isFetching,
    },
  }
}
